import React, { useState } from "react";
export function PaginatorButtons({ total, onClick, page }) {
    const buttonsPerPage = 4;
    const [currentPage, setCurrentPage] = useState(() => {
        if (page && page > 0 && page < total)
            return page;
        if (page && page >= total)
            return total - 1;
        return 0;
    });
    const onClickPage = (page) => {
        setCurrentPage(page);
        onClick && onClick(page);
    };
    if (total <= buttonsPerPage + 2) {
        return React.createElement(Buttons, { currentPage: currentPage, total: total, onClick: onClickPage });
    }
    else if (currentPage < buttonsPerPage - 1) {
        return React.createElement(ButtonsOnStart, { buttonsPerPage: buttonsPerPage, currentPage: currentPage, onClick: onClickPage, total: total });
    }
    else if (currentPage >= total - buttonsPerPage + 1) {
        return React.createElement(ButtonsOnEnd, { buttonsPerPage: buttonsPerPage, currentPage: currentPage, onClick: onClickPage, total: total });
    }
    else {
        return React.createElement(ButtonsEllipsed, { buttonsPerPage: buttonsPerPage, currentPage: currentPage, onClick: onClickPage, total: total });
    }
}
const Button = ({ page, onClick, active }) => React.createElement("button", { className: `ltg-list-pagination-btn${active ? ' active' : ''}`, type: "button", onClick: () => onClick(page) }, page + 1);
const Ellipsis = () => React.createElement("span", { className: "ltg-posts-ellipsis" }, "...");
const ButtonsEllipsed = ({ currentPage, total, onClick, buttonsPerPage }) => {
    const buttons = [];
    buttons.push(React.createElement(Button, { key: 'page-zero', page: 0, onClick: () => { onClick(0); } }));
    if (currentPage >= buttonsPerPage - 1) {
        buttons.push(React.createElement(Ellipsis, { key: 'ellipsis-start' }));
    }
    for (let i = currentPage - 1; i < currentPage + 2; i++) {
        buttons.push(React.createElement(Button, { key: i, page: i, onClick: () => onClick(i), active: i === currentPage }));
    }
    if (currentPage < total - buttonsPerPage + 1) {
        buttons.push(React.createElement(Ellipsis, { key: 'ellipsis-end' }));
    }
    buttons.push(React.createElement(Button, { key: total, page: total - 1, onClick: () => { onClick(total - 1); } }));
    return React.createElement(React.Fragment, null, buttons);
};
const Buttons = ({ currentPage, total, onClick }) => {
    const buttons = [];
    for (let i = 0; i < total; i++) {
        buttons.push(React.createElement(Button, { key: i, page: i, onClick: () => onClick(i), active: i === currentPage }));
    }
    return React.createElement(React.Fragment, null, buttons);
};
const ButtonsOnStart = ({ currentPage, total, onClick, buttonsPerPage }) => {
    const buttons = [];
    for (let i = 0; i < buttonsPerPage && i < total; i++) {
        buttons.push(React.createElement(Button, { key: i, page: i, onClick: () => onClick(i), active: i === currentPage }));
    }
    if (total > buttonsPerPage + 2) {
        buttons.push(React.createElement(Ellipsis, { key: 'ellipsis-end' }));
        buttons.push(React.createElement(Button, { key: total, page: total - 1, onClick: () => { onClick(total - 1); } }));
    }
    return (React.createElement(React.Fragment, null, buttons));
};
const ButtonsOnEnd = ({ currentPage, total, onClick, buttonsPerPage }) => {
    const buttons = [];
    const firstPage = total - buttonsPerPage;
    buttons.push(React.createElement(Button, { key: 'page-zero', page: 0, onClick: () => { onClick(0); } }));
    buttons.push(React.createElement(Ellipsis, { key: 'ellipsis-start' }));
    for (let i = firstPage; i < total; i++) {
        buttons.push(React.createElement(Button, { key: i, page: i, onClick: () => onClick(i), active: i === currentPage }));
    }
    return (React.createElement(React.Fragment, null, buttons));
};
